<template>
  <v-card class="engine-card" style="max-height:340px;min-height:250px;margin:5px;" @click="selVessel">
    <v-card-title style="height:10%;color:rgb(144,170,218);">
      <div primary class="title">{{ cardData.name }}</div>
      <v-spacer/>
      <div style="font-size:15px;color:rgb(33,33,33);">Last update: {{ cardData.lastUpdate }}</div>
    </v-card-title>
    <v-card-actions fill-height style="height:90%;">
      <v-container grid-list-md style="padding:5px;height:100%;">
        <v-layout row>
          <v-flex d-flex md3 class="clickable" @click='goToVessel()'>{{ cardData.vessel }}</v-flex>
        </v-layout>
        <v-layout row style="margin-top: 10px;">
          <v-layout column>
            <v-layout row>
              <v-flex d-flex md3 class="info-title">Engine KPI</v-flex>
            </v-layout>
            <v-layout row>
              <v-flex d-flex xs3>
                <div v-if="cardData.engineKPI<0" style="color:rgb(117,117,117);display:flex;align-items:center;justify-content:center;font-size:20px;">-</div>
                <div v-else-if="cardData.engineColor==20" style="color:rgb(205, 57, 64);display:flex;align-items:center;justify-content:center;font-size:20px;">{{ cardData.engineKPI }} %</div>
                <div v-else style="color:rgb(117,117,117);display:flex;align-items:center;justify-content:center;font-size:20px;">{{ cardData.engineKPI }} %</div>
              </v-flex>
              <v-flex d-flex xs9 style="align-items:center;">
                <div v-if="cardData.engineColor==0" :style="'height:25px; border:none; color:rgb(60, 171, 48); background-color:rgb(60, 171, 48); width:' + cardData.engineKPI+ '%;' "/>
                <div v-if="cardData.engineColor==10" :style="'height:25px; border:none; color:rgb(255, 184, 29); background-color:rgb(255, 184, 29); width:' + cardData.engineKPI+ '%;' "/>
                <div v-if="cardData.engineColor==20" :style="'height:25px; border:none; color:rgb(205, 57, 64); background-color:rgb(205, 57, 64); width:' + cardData.engineKPI+ '%;' "/>
                <div :style="'height:25px; border:none; color:rgb(244,244,244);  background-color:rgb(244,244,244); width:' + (100-cardData.engineKPI)+ '%;' "/>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-layout>
        <v-layout row style="margin-top: 10px;">
          <v-layout column>
            <v-flex row class="info-title">Last fault</v-flex>
            <v-flex v-if="cardData.fault.last" row style="align-items:center;margin-left: 7px !important;">
              <div style="font-size:16px !important; line-height:16px !important;">{{ cardData.fault.last }}</div>
            </v-flex>
            <v-flex v-else row style="align-items:center;margin-left: 7px !important;">
              <div style="font-size:20px;">-</div>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout row style="margin-top: 10px;" class="engine-trend-line">
          <v-flex d-flex md3>
            <Trendline v-bind:trendData="cardData['bsfc']"/>
          </v-flex>
          <v-flex d-flex md3>
            <Trendline v-bind:trendData="cardData['sloc']"/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-layout column>
            <div style="text-align: center; margin-top: 1rem">
              <span style="max-width: 90px; text-align: center; color: rgb(144, 170, 218); font-weight: 500; border-bottom: 1px solid rgb(144, 170, 218); padding-bottom: 1px;">Show tickets</span>
            </div>
          </v-layout>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>

import Trendline from './Trendline'
import {store} from "../main.js";

export default {
  name: "EngineCard",
  components: {
    Trendline
  },
  props: {
    cardData: Object
  },
  data: function () {
    return {}
  },
  methods: {
    goToVessel() {
      window.$cookies.set('vessel', this.cardData.vessel);
      let vessel_url = new URL(store.config.ship_co)
      vessel_url.pathname += `vessel-view/${this.cardData.vessel}`
      window.open(vessel_url.toString());
    },
    selVessel() {
      store.selectedTicketsVessel = this.cardData.vessel;
    }
  },
  mounted() {
  },
  watch: {}
}
</script>

<style scoped>
.engine-card {
  width: 100%;
  width: -moz-available; /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  width: fill-available;
}

.info-title {
  align-items: center;
  font-size: 16px;
  color: rgb(118, 118, 118);
  margin-left: 7px !important;
  padding-bottom: 0 !important;
}
</style>

<style>
.engine-trend-line .trend-line-title {
  align-items: center;
  font-size: 16px;
  color: rgb(118, 118, 118);
  padding-bottom: 0 !important;
}

.engine-trend-line .trend-line-display, .engine-trend-line .trend-line-title {
  text-align: center !important;
}
</style>


